import React, { useState, useEffect } from 'react';
import './About.css';

const About = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Simple mount animation trigger
    setIsVisible(true);
  }, []);

  const features = [
    {
      icon: '🏆',
      title: 'Premium Quality',
      description: 'All our instruments are manufactured using the highest grade stainless steel and undergo rigorous quality testing.'
    },
    {
      icon: '🔬',
      title: 'Advanced Technology',
      description: 'We utilize cutting-edge manufacturing processes and precision engineering for superior instrument performance.'
    },
    {
      icon: '⚕️',
      title: 'Medical Certified',
      description: 'Our products meet international medical standards and are certified by leading healthcare regulatory bodies.'
    },
    {
      icon: '🌍',
      title: 'Global Reach',
      description: 'Serving healthcare professionals worldwide with reliable delivery and comprehensive customer support.'
    },
    {
      icon: '🔧',
      title: 'Custom Solutions',
      description: 'We offer customized surgical instruments tailored to specific medical procedures and requirements.'
    },
    {
      icon: '📞',
      title: '24/7 Support',
      description: 'Round-the-clock customer service and technical support to ensure uninterrupted medical operations.'
    }
  ];

  return (
    <section id="about" className="about section">
      <div className="about-cover" style={{ backgroundImage: "url('/our.jpg')", backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="container">
          <div className={`section-header ${isVisible ? 'animate-in' : ''}`}>
            <h2 className="section-title">About Purelife impex</h2>
            <p className="section-description">
              Leading the industry in surgical instrument manufacturing with precision, quality, and innovation
            </p>
          </div>

          <div className="about-content">
            <div className={`about-text ${isVisible ? 'animate-in' : ''}`}>
              <div className="text-block">
                <h3>Our Mission</h3>
                <p>
                  At Purelife impex, we are committed to delivering premium medical instruments that meet global standards.
                  world-class surgical instruments that enable medical professionals to deliver 
                  exceptional patient care. Our mission is to combine traditional craftsmanship 
                  with modern technology to create instruments that meet the evolving needs of 
                  the medical community.
                </p>
              </div>
              
              <div className="text-block">
                <h3>Our Vision</h3>
                <p>
                  To be the global leader in surgical instrument innovation, setting new 
                  standards for quality, precision, and reliability in medical equipment. 
                  We envision a future where our instruments contribute to better surgical 
                  outcomes and improved patient safety worldwide.
                </p>
              </div>

              <div className="text-block">
                <h3>Quality Commitment</h3>
                <p>
                  Every instrument we manufacture undergoes stringent quality control processes. 
                  From material selection to final inspection, we maintain the highest standards 
                  to ensure that our products meet and exceed international medical device regulations.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        {/* Features */}
        <div className={`features-section ${isVisible ? 'animate-in' : ''}`}>
          <h3 className="features-title">Why Choose Purelife impex?</h3>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div 
                key={index} 
                className="feature-card"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="feature-icon">{feature.icon}</div>
                <h4 className="feature-title">{feature.title}</h4>
                <p className="feature-description">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className={`cta-section ${isVisible ? 'animate-in' : ''}`}>
          <div className="cta-content">
            <h3>Ready to Experience Excellence?</h3>
            <p>Join thousands of medical professionals who trust Purelife impex for their surgical instrument needs.</p>
            <div className="cta-actions">
              <a className="btn btn-primary btn-large" href="/Oxgen%20Surgicals.pdf" target="_blank" rel="noopener noreferrer">Request Catalog</a>
              <a className="btn btn-outline btn-large" href="/#contact">Schedule Consultation</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;